(function () {
  if (window.XPCollectionPopup) { window.XPCollectionPopup.scan(document); return; }
  // Load the popup styles once, from the URL the section put on this script tag.
  (function () {
    var me = document.currentScript, href = me && me.getAttribute('data-css');
    if (!href || document.querySelector('link[data-xpc-css]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = href; l.setAttribute('data-xpc-css', '');
    document.head.appendChild(l);
  })();
  var ICON = {
    eye: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>',
    bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 7h12l1 13H5z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>',
    spin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M12 3a9 9 0 1 0 9 9"/></svg>',
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>'
  };
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tpl(str, o) { return String(str || '').replace(/\[(\w+)\]/g, function (m, k) { return o && o[k] != null ? o[k] : m; }); }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CACHE = {};

  /* Fetch a collection's products through this section file rendered on the collection URL. */
  /* A card points at a collection handle, or at any collection-style path (vendor / type pages). */
  function srcOf(card) { return card.dataset.src || ('collections/' + encodeURIComponent(card.dataset.handle)); }
  function load(cfg, path) {
    var key = path + '|' + cfg.file;
    if (CACHE[key]) return CACHE[key];
    var url = String(cfg.root || '/').replace(/\/?$/, '/') + path + (path.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + cfg.file;
    CACHE[key] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var node = doc.querySelector('[data-xpc-data]');
      if (!node) throw new Error('no data');
      return JSON.parse(node.textContent);
    }).catch(function (e) { delete CACHE[key]; throw e; });
    return CACHE[key];
  }

  // Texts: a text typed in the editor wins. Empty (or Arabic on a non-Arabic page) = built-in text in the site language.
  var XPD = {ar: {"count":"[count] منتج","add":"أضف للعربة","choose":"اختار","added":"اتضاف","added_msg":"اتضاف للعربة","open_cart":"افتح العربة","sold_out":"خلصان","from":"من","quick_view":"معاينة سريعة","view_all":"شوف كل المنتجات","close":"اقفل","sort_default":"الترشيحات","sort_low":"الأقل سعراً","sort_high":"الأعلى سعراً","sort_sale":"العروض","empty":"مفيش منتجات هنا دلوقتي","error":"مقدرناش نحمّل المنتجات","retry":"جرّب تاني","view_page":"شوف صفحة المنتج كاملة","variant":"اختار النوع / الحجم"}, en: {"count":"[count] products","add":"Add to cart","choose":"Choose","added":"Added","added_msg":"Added to cart","open_cart":"View cart","sold_out":"Sold out","from":"From","quick_view":"Quick view","view_all":"View all products","close":"Close","sort_default":"Featured","sort_low":"Price: low to high","sort_high":"Price: high to low","sort_sale":"On sale","empty":"No products here yet","error":"Couldn't load the products","retry":"Try again","view_page":"View full product page","variant":"Choose an option"}};
  function XPT(t) {
    var ar = /^ar/i.test(document.documentElement.lang || ''), d = XPD[ar ? 'ar' : 'en'], o = {}, k, v;
    t = t || {};
    for (k in d) { v = t[k]; if (!v || (!ar && /[؀-ۿ]/.test(v))) v = d[k]; o[k] = v; }
    return o;
  }

  var P = null; // the single popup element, shared by all sections

  function Popup() {
    var el = document.createElement('div');
    el.className = 'xpc';
    el.hidden = true;
    if (document.documentElement.dir) el.setAttribute('dir', document.documentElement.dir);
    el.innerHTML = '<div class="xpc__bg" data-x="close"></div><div class="xpc__panel" role="dialog" aria-modal="true" aria-labelledby="xpc-title"><span class="xpc__grab" aria-hidden="true"></span>' +
      '<button type="button" class="xpc__x" data-x="close"></button><div class="xpc__scroll"></div><div class="xpc__toast" role="status" aria-live="polite"></div></div>';
    document.body.appendChild(el);
    this.el = el;
    this.scroll = el.querySelector('.xpc__scroll');
    this.toastEl = el.querySelector('.xpc__toast');
    var self = this;
    el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-x]');
      if (!b) return;
      var a = b.getAttribute('data-x');
      if (a === 'close') self.close();
      else if (a === 'qv') { e.preventDefault(); self.qvOpen(b); }
      else if (a === 'sort') { self.sort = b.getAttribute('data-k'); self.renderGrid(true); }
      else if (a === 'add') { e.preventDefault(); self.add(b); }
      else if (a === 'retry') self.show(self.card, true);
    });
    var warmQ = function (e) {
      var b = e.target.closest && e.target.closest('[data-x="qv"]');
      var api = qvApi();
      if (b && api && api.prefetch) api.prefetch(b.getAttribute('data-h'));
    };
    el.addEventListener('pointerenter', warmQ, true);
    el.addEventListener('touchstart', warmQ, { passive: true, capture: true });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); self.close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(el.querySelectorAll('button,select,a[href]'), function (x) { return !x.disabled && x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    // Phone back button closes the popup instead of leaving the page.
    window.addEventListener('popstate', function () {
      if (self.isOpen && !(history.state && history.state.xpc)) self.close(true);
    });
    // Swipe the grab area / hero down to close on phones.
    var startY = null;
    el.querySelector('.xpc__panel').addEventListener('touchstart', function (e) { startY = self.scroll.scrollTop <= 0 ? e.touches[0].clientY : null; }, { passive: true });
    el.querySelector('.xpc__panel').addEventListener('touchend', function (e) { if (startY != null && e.changedTouches[0].clientY - startY > 110) self.close(); startY = null; }, { passive: true });
  }

  Popup.prototype.open = function (card) {
    var self = this, el = this.el, sec = card.closest('[data-xpc-section]');
    this.card = card;
    this.cfg = sec.__xpc;
    this.t = XPT(this.cfg.t);
    this.sort = 'default';
    this.data = null;
    el.setAttribute('style', sec.getAttribute('style') || '');
    el.querySelector('.xpc__x').innerHTML = ICON.x + '<span>' + esc(this.t.close) + '</span>';
    this.lastFocus = document.activeElement;
    this.show(card, false);
    if (!this.isOpen) {
      this.isOpen = true;
      el.hidden = false;
      void el.offsetWidth;
      el.classList.add('is-open');
      document.documentElement.classList.add('xpc-lock');
      try { history.pushState({ xpc: 1 }, ''); this.pushed = true; } catch (e) { this.pushed = false; }
    }
    el.querySelector('.xpc__x').focus({ preventScroll: true });
  };
  Popup.prototype.show = function (card, retry) {
    var self = this, d = card.dataset, t = this.t;
    var head = (d.img ? '<div class="xpc__hero"><img src="' + esc(d.img) + '" alt="" decoding="async"></div>' : '<div class="xpc__hero"></div>') +
      '<div class="xpc__head">' + (d.brand ? '<span class="xpc__brand">' + esc(d.brand) + '</span>' : '') +
      '<h2 class="xpc__title" id="xpc-title">' + esc(d.title) + '</h2>' +
      '<div class="xpc__meta">' + (d.count ? '<span class="xpc__pill">' + esc(tpl(t.count, { count: d.count })) + '</span>' : '') + '</div>' +
      (d.desc ? '<p class="xpc__desc">' + esc(d.desc) + '</p>' : '') + '</div>';
    var skel = '';
    for (var i = 0; i < 4; i++) skel += '<div class="xpc-skel" aria-hidden="true"><i></i><i></i><i></i></div>';
    this.scroll.innerHTML = head + '<div class="xpc__barwrap"></div><div class="xpc__grid" aria-busy="true">' + skel + '</div>' +
      '<div class="xpc__foot"><a class="xpc__all" href="' + esc(d.url) + '">' + esc(t.view_all) + ICON.arrow + '</a></div>';
    this.scroll.scrollTop = 0;
    this.hideToast();
    load(this.cfg, srcOf(card)).then(function (data) {
      if (self.card !== card || !self.isOpen) return;
      self.data = data;
      var meta = self.scroll.querySelector('.xpc__meta');
      if (meta && !d.count && data.count != null) meta.innerHTML = '<span class="xpc__pill">' + esc(tpl(t.count, { count: data.count })) + '</span>';
      var hero = self.scroll.querySelector('.xpc__hero');
      var hi = data.img || (data.products && data.products[0] && data.products[0].i);
      if (hero && !d.img && hi) hero.innerHTML = '<img src="' + esc(hi) + '" alt="" decoding="async">';
      self.renderBar();
      self.renderGrid(false);
    }).catch(function () {
      if (self.card !== card) return;
      self.scroll.querySelector('.xpc__grid').outerHTML = '<div class="xpc__msg"><span>' + esc(t.error) + '</span><button type="button" data-x="retry">' + esc(t.retry) + '</button></div>';
    });
  };
  Popup.prototype.list = function () {
    var ps = (this.data.products || []).slice(0, this.cfg.limit || 24);
    if (this.sort === 'low') ps.sort(function (a, b) { return a.p - b.p; });
    else if (this.sort === 'high') ps.sort(function (a, b) { return b.p - a.p; });
    else if (this.sort === 'sale') ps = ps.filter(function (p) { return p.cp > p.p; });
    return ps;
  };
  Popup.prototype.renderBar = function () {
    var t = this.t, wrap = this.scroll.querySelector('.xpc__barwrap');
    if (!wrap) return;
    if (!this.cfg.sort || !this.data.products || this.data.products.length < 3) { wrap.innerHTML = ''; return; }
    var hasSale = this.data.products.some(function (p) { return p.cp > p.p; });
    var opts = [['default', t.sort_default], ['low', t.sort_low], ['high', t.sort_high]];
    if (hasSale) opts.push(['sale', t.sort_sale]);
    var self = this;
    wrap.innerHTML = '<div class="xpc__bar">' + opts.map(function (o) {
      var on = self.sort === o[0];
      return '<button type="button" class="xpc__chip' + (on ? ' is-on' : '') + '" data-x="sort" data-k="' + o[0] + '" aria-pressed="' + on + '">' + esc(o[1]) + '</button>';
    }).join('') + '</div>';
  };
  Popup.prototype.cardHtml = function (p) {
    var c = this.cfg, t = this.t, cur = c.currency === 'with_currency';
    var sale = p.cp > p.p, price = cur ? p.pfc : p.pf, comp = cur ? p.cfc : p.cf;
    var off = sale ? Math.round((1 - p.p / p.cp) * 100) : 0;
    var imgs = p.i ? '<img src="' + esc(p.i) + '" alt="' + esc(p.t) + '" loading="lazy" decoding="async" width="500" height="500">' + (p.i2 ? '<img src="' + esc(p.i2) + '" alt="" loading="lazy" decoding="async" width="500" height="500">' : '') : '';
    var badge = !p.a ? '<span class="xpc-soldout">' + esc(t.sold_out) + '</span>' : (sale && c.badge && off > 0 ? '<span class="xpc-badge">-' + off + '%</span>' : '');
    var qv = c.quickView ? '<button type="button" class="xpc-qv" data-x="qv" data-h="' + esc(p.h) + '" aria-label="' + esc(t.quick_view + ': ' + p.t) + '">' + ICON.eye + '<span>' + esc(t.quick_view) + '</span></button>' : '';
    var btn = '';
    if (c.quickAdd) {
      if (!p.a) btn = '<button type="button" class="xpc-add" disabled>' + esc(t.sold_out) + '</button>';
      else if (p.vc > 1) btn = c.quickView
        ? '<button type="button" class="xpc-add xpc-add--ghost" data-x="qv" data-h="' + esc(p.h) + '">' + esc(t.choose) + '</button>'
        : '<a class="xpc-add xpc-add--ghost" href="' + esc(p.u) + '">' + esc(t.choose) + '</a>';
      else btn = '<button type="button" class="xpc-add" data-x="add" data-id="' + p.vid + '" data-img="' + esc(p.i || '') + '">' + ICON.bag + '<span>' + esc(t.add) + '</span></button>';
    }
    return '<div class="xpc-card"><div class="xpc-card__mwrap"><a class="xpc-card__media" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' + imgs + '</a>' + badge + qv + '</div>' +
      '<div class="xpc-card__info"><a class="xpc-card__title" href="' + esc(p.u) + '">' + esc(p.t) + '</a>' +
      '<div class="xpc-card__price' + (sale ? ' is-sale' : '') + '"><span>' + (p.varies ? esc(t.from) + ' ' : '') + esc(price) + '</span>' + (sale ? '<s>' + esc(comp) + '</s>' : '') + '</div></div>' + btn + '</div>';
  };
  Popup.prototype.renderGrid = function (fromSort) {
    var grid = this.scroll.querySelector('.xpc__grid');
    if (!grid || !this.data) return;
    var ps = this.list(), self = this;
    if (fromSort) this.renderBar();
    grid.removeAttribute('aria-busy');
    grid.classList.toggle('is-static', reduce);
    grid.innerHTML = ps.length ? ps.map(function (p) { return self.cardHtml(p); }).join('') : '<div class="xpc__msg" style="grid-column:1/-1">' + esc(this.t.empty) + '</div>';
  };

  /* Quick add: one request returns the cart drawer HTML too, so the theme drawer is filled without a reload. */
  function themeDrawer() {
    var d = document.querySelector('m-cart-drawer') || document.querySelector('cart-drawer');
    return d && typeof d.getSectionsToRender === 'function' ? d : null;
  }
  function fillDrawer(d, j) {
    var done = false, cache = {};
    d.getSectionsToRender().forEach(function (x) {
      var id = x.section || x.id, html = j.sections && j.sections[id];
      if (!html) return;
      var el = x.selector ? document.querySelector(x.selector) : document.getElementById(x.id);
      if (!el) return;
      var doc = cache[id] || (cache[id] = new DOMParser().parseFromString(html, 'text/html'));
      var src = x.selector ? doc.querySelector(x.selector) : doc.querySelector('.shopify-section');
      if (src) { el.innerHTML = src.innerHTML; done = true; }
    });
    d.classList.remove('m-cart--empty', 'is-empty');
    var items = d.querySelector('m-cart-drawer-items, cart-drawer-items');
    if (items) items.classList.remove('m-cart--empty', 'is-empty');
    return done;
  }
  Popup.prototype.add = function (b) {
    var self = this, c = this.cfg, t = this.t;
    if (b.classList.contains('is-busy') || b.classList.contains('is-done')) return;
    b.classList.add('is-busy');
    b.innerHTML = ICON.spin + '<span>' + esc(t.add) + '</span>';
    var body = { items: [{ id: Number(b.getAttribute('data-id')), quantity: 1 }] };
    var d = themeDrawer();
    if (d) {
      var ids = [];
      try { d.getSectionsToRender().forEach(function (x) { var id = x.section || x.id; if (ids.indexOf(id) < 0) ids.push(id); }); } catch (e) {}
      if (ids.length) { body.sections = ids; body.sections_url = window.location.pathname; }
    }
    fetch(c.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'error'); return j; }); })
      .then(function (j) {
        b.classList.remove('is-busy');
        b.classList.add('is-done');
        b.innerHTML = ICON.check + '<span>' + esc(t.added) + '</span>';
        setTimeout(function () { if (b.isConnected) { b.classList.remove('is-done'); b.innerHTML = ICON.bag + '<span>' + esc(t.add) + '</span>'; } }, 2200);
        var sync = function () {
          try {
            if (d && j.sections) fillDrawer(d, j);
            else if (d && typeof d.onCartDrawerUpdate === 'function') d.onCartDrawerUpdate();
            if (window.FoxKitV2 && window.FoxKitV2.Modules && window.FoxKitV2.Modules.InCart) window.FoxKitV2.Modules.InCart.getCart();
            if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, j);
          } catch (e) {}
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        };
        if (c.after === 'drawer' && d && typeof d.open === 'function') { sync(); self.close(); setTimeout(function () { d.open(); }, 50); }
        else {
          self.toast(b.getAttribute('data-img'));
          /* heavy theme work runs after the "added" state has painted, so the click never freezes */
          requestAnimationFrame(function () { setTimeout(sync, 120); });
        }
      })
      .catch(function (e) {
        b.classList.remove('is-busy');
        b.innerHTML = ICON.bag + '<span>' + esc(t.add) + '</span>';
        self.toast(null, e.message);
      });
  };
  Popup.prototype.toast = function (img, err) {
    var self = this, t = this.t, el = this.toastEl, d = themeDrawer();
    el.innerHTML = (img ? '<img src="' + esc(img) + '" alt="">' : '') + '<span>' + esc(err || t.added_msg) + '</span>' +
      (err ? '' : '<a href="' + esc(this.cfg.cartUrl) + '" data-x="cart">' + esc(t.open_cart) + '</a>');
    var a = el.querySelector('[data-x="cart"]');
    if (a && d && typeof d.open === 'function') a.addEventListener('click', function (e) { e.preventDefault(); self.close(); setTimeout(function () { d.open(); }, 50); });
    el.classList.add('is-on');
    clearTimeout(this.toastT);
    this.toastT = setTimeout(function () { self.hideToast(); }, 4000);
  };
  Popup.prototype.hideToast = function () { this.toastEl.classList.remove('is-on'); };
  Popup.prototype.close = function (fromPop) {
    var self = this, el = this.el;
    if (!this.isOpen) return;
    this.isOpen = false;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('xpc-lock');
    setTimeout(function () { if (!self.isOpen) el.hidden = true; }, reduce ? 0 : 380);
    if (this.pushed && !fromPop) { this.pushed = false; try { history.back(); } catch (e) {} }
    this.pushed = false;
    if (this.lastFocus && this.lastFocus.focus && document.contains(this.lastFocus)) this.lastFocus.focus({ preventScroll: true });
  };

  /* ---------- Quick view: the site's shared quick view (assets/product-quick-view.js) ---------- */
  function qvApi() {
    var m = window.MinimogTheme;
    return m && m.ProductQuickView && typeof m.ProductQuickView.open === 'function' ? m.ProductQuickView : null;
  }
  Popup.prototype.qvOpen = function (b) {
    var self = this, t = this.t, c = this.cfg, api = qvApi();
    if (!api) { var link = b.closest('.xpc-card') && b.closest('.xpc-card').querySelector('a[href]'); if (link) window.location.href = link.href; return; }
    api.open(b.getAttribute('data-h'), b, {
      t: { add: t.add, added: t.added, sold: t.sold_out, from: t.from, close: t.close, page: t.view_page },
      onAdded: function (j, d, img) {
        if (!self.isOpen) return;
        if (c.after === 'drawer' && d && typeof d.open === 'function') { self.close(); setTimeout(function () { d.open(); }, 60); }
        else self.toast(img);
      }
    });
  };

  function init(sec) {
    if (!sec || sec.__xpc) return;
    try { sec.__xpc = JSON.parse(sec.querySelector('[data-xpc-config]').textContent); } catch (e) { return; }
    var cfg = sec.__xpc;
    // Warm the cache as soon as a shopper shows intent, so the popup opens with products ready.
    var warm = function (e) {
      var card = e.target.closest && e.target.closest('[data-xpc-card]');
      if (card) load(cfg, srcOf(card)).catch(function () {});
    };
    sec.addEventListener('pointerenter', warm, true);
    sec.addEventListener('touchstart', warm, { passive: true, capture: true });
    sec.addEventListener('focusin', warm);
    sec.addEventListener('click', function (e) {
      var trig = e.target.closest('[data-xpc-open]');
      if (!trig || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      var card = trig.closest('[data-xpc-card]');
      if (!card) return;
      e.preventDefault();
      if (!P) P = new Popup();
      P.open(card);
    });
  }
  function scan(root) {
    if (!root) return;
    if (root.matches && root.matches('[data-xpc-section]')) init(root);
    if (root.querySelectorAll) Array.prototype.forEach.call(root.querySelectorAll('[data-xpc-section]'), init);
  }
  window.XPCollectionPopup = { init: init, scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
  // Theme editor: sections re-rendered in place need binding again.
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
